/**
 * Update Custom Checklist Task API
 * Feature: 020-thinka-and-create
 */

import axiosInstance from '../axiosInstance';
import {
  CreateCustomChecklistTaskRequest,
  CustomChecklistTaskResponse,
} from '../createCustomChecklistTask';

export type UpdateCustomChecklistTaskRequest = CreateCustomChecklistTaskRequest;

export const updateCustomChecklistTask = async (
  id: string,
  request: UpdateCustomChecklistTaskRequest
): Promise<CustomChecklistTaskResponse> => {
  const response = await axiosInstance.patch<CustomChecklistTaskResponse>(
    `/api/custom-checklist-tasks/${id}`,
    request
  );

  return response.data;
};
